/**
 * View-local model for the sales-rep view: the shapes and pure helpers the
 * refreshed ("plain") layout's side panel needs. The view itself — and the
 * legacy layout it keeps verbatim — stays in salesRepView.tsx.
 */

export interface RankEntry {
  /** 1-based position in the FULL ranking, not just the visible slice. */
  rank: number;
  name: string;
  value: number;
  isYou: boolean;
}

export const RANK_LIST_SIZE = 5;

/**
 * Build the top-N rows for a side-panel ranking from the same parallel
 * label/value arrays the ranking BarCharts plot. Descending by value; if the
 * current rep falls outside the top N they replace the last visible row,
 * keeping their true rank so the list never overstates their position.
 */
export const buildRankEntries = (
  labels: any[],
  values: any[],
  you: string | undefined
): RankEntry[] => {
  const rows: RankEntry[] = (Array.isArray(labels) ? labels : [])
    .map((name: any, i: number) => ({
      name: String(name),
      value: Number(values?.[i] ?? 0),
      isYou: !!you && String(name) === you,
      rank: 0,
    }))
    .sort((a, b) => b.value - a.value)
    .map((row, i) => ({ ...row, rank: i + 1 }));

  const top = rows.slice(0, RANK_LIST_SIZE);
  const youRow = rows.find((r) => r.isYou);
  if (youRow && !top.some((r) => r.isYou)) top[top.length - 1] = youRow;
  return top;
};
